// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo_logoContainer__3A_p7","pointer":"Logo_pointer__3eCN-","logoOnly":"Logo_logoOnly__2qQKV","headerTitle":"Logo_headerTitle__2880O"};